// @ts-nocheck
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
import * as Types from "../../__generated__/schema.graphql.types";

const defaultOptions = {} as const;
export type PayrollShiftsQueryVariables = Types.Exact<{
  medspaId: Types.Scalars["bigint"]["input"];
}>;

export type PayrollShiftsQuery = {
  __typename?: "query_root";
  medspaByPk?: {
    __typename?: "medspa";
    userMedspas: Array<{
      __typename?: "userMedspa";
      id: string;
      payrollShifts: Array<{
        __typename?: "PayrollShifts";
        id: string;
        startTime?: string | null;
        endTime?: string | null;
        approvalStatus: string;
        manualBreakTime?: number | null;
        payrollBreaks: Array<{
          __typename?: "PayrollBreak";
          id: string;
          startTime?: string | null;
          endTime?: string | null;
        }>;
      }>;
      user: { __typename?: "user"; id: string; fullName?: string | null };
    }>;
  } | null;
};

export type CurrentUserOpenShiftQueryVariables = Types.Exact<{
  userMedspaId: Types.Scalars["bigint"]["input"];
}>;

export type CurrentUserOpenShiftQuery = {
  __typename?: "query_root";
  userMedspaByPk?: {
    __typename?: "userMedspa";
    payrollShifts: Array<{
      __typename?: "PayrollShifts";
      id: string;
      startTime?: string | null;
      payrollBreaks: Array<{
        __typename?: "PayrollBreak";
        id: string;
        startTime?: string | null;
        endTime?: string | null;
      }>;
    }>;
  } | null;
};

export type StartWorkShiftMutationVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
}>;

export type StartWorkShiftMutation = {
  __typename?: "mutation_root";
  clockin?: {
    __typename?: "ClockinMutations";
    startWorkShift?: {
      __typename?: "StartWorkShift";
      ok?: boolean | null;
      message?: string | null;
    } | null;
  } | null;
};

export type EndWorkShiftMutationVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
}>;

export type EndWorkShiftMutation = {
  __typename?: "mutation_root";
  clockin?: {
    __typename?: "ClockinMutations";
    endWorkShift?: {
      __typename?: "EndWorkShift";
      ok?: boolean | null;
      message?: string | null;
    } | null;
  } | null;
};

export type StartBreakMutationVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
}>;

export type StartBreakMutation = {
  __typename?: "mutation_root";
  clockin?: {
    __typename?: "ClockinMutations";
    startBreak?: {
      __typename?: "StartBreak";
      ok?: boolean | null;
      message?: string | null;
    } | null;
  } | null;
};

export type EndBreakMutationVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
}>;

export type EndBreakMutation = {
  __typename?: "mutation_root";
  clockin?: {
    __typename?: "ClockinMutations";
    endBreak?: {
      __typename?: "EndBreak";
      ok?: boolean | null;
      message?: string | null;
    } | null;
  } | null;
};

export type DeleteShiftMutationVariables = Types.Exact<{
  shiftId: Types.Scalars["String"]["input"];
}>;

export type DeleteShiftMutation = {
  __typename?: "mutation_root";
  clockin?: {
    __typename?: "ClockinMutations";
    deleteWorkShift?: {
      __typename?: "DeleteWorkShift";
      ok?: boolean | null;
      message?: string | null;
    } | null;
  } | null;
};

export type ApproveOrDenyShiftsMutationVariables = Types.Exact<{
  medspaId: Types.Scalars["BigInt"]["input"];
  approveOrDeny: Types.ApproveOrDeny;
  shiftIds:
    | Array<Types.Scalars["BigInt"]["input"]>
    | Types.Scalars["BigInt"]["input"];
}>;

export type ApproveOrDenyShiftsMutation = {
  __typename?: "mutation_root";
  clockin?: {
    __typename?: "ClockinMutations";
    approveOrDenyWorkShifts?: {
      __typename?: "ApproveOrDenyWorkShifts";
      ok?: boolean | null;
      message?: string | null;
    } | null;
  } | null;
};

export const PayrollShiftsDocument = gql`
  query PayrollShifts($medspaId: bigint!) {
    medspaByPk(id: $medspaId) {
      userMedspas(where: { payrollShifts: { id: { _isNull: false } } }) {
        id
        payrollShifts(
          where: {
            _and: { endTime: { _isNull: false }, deletedAt: { _isNull: true } }
          }
        ) {
          id
          startTime
          endTime
          approvalStatus
          manualBreakTime
          payrollBreaks {
            id
            startTime
            endTime
          }
        }
        user {
          id
          fullName
        }
      }
    }
  }
`;

/**
 * __usePayrollShiftsQuery__
 *
 * To run a query within a React component, call `usePayrollShiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollShiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollShiftsQuery({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function usePayrollShiftsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PayrollShiftsQuery,
    PayrollShiftsQueryVariables
  > &
    (
      | { variables: PayrollShiftsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PayrollShiftsQuery, PayrollShiftsQueryVariables>(
    PayrollShiftsDocument,
    options
  );
}
export function usePayrollShiftsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PayrollShiftsQuery,
    PayrollShiftsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PayrollShiftsQuery, PayrollShiftsQueryVariables>(
    PayrollShiftsDocument,
    options
  );
}
export function usePayrollShiftsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PayrollShiftsQuery,
        PayrollShiftsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PayrollShiftsQuery,
    PayrollShiftsQueryVariables
  >(PayrollShiftsDocument, options);
}
export type PayrollShiftsQueryHookResult = ReturnType<
  typeof usePayrollShiftsQuery
>;
export type PayrollShiftsLazyQueryHookResult = ReturnType<
  typeof usePayrollShiftsLazyQuery
>;
export type PayrollShiftsSuspenseQueryHookResult = ReturnType<
  typeof usePayrollShiftsSuspenseQuery
>;
export type PayrollShiftsQueryResult = Apollo.QueryResult<
  PayrollShiftsQuery,
  PayrollShiftsQueryVariables
>;
export const CurrentUserOpenShiftDocument = gql`
  query CurrentUserOpenShift($userMedspaId: bigint!) {
    userMedspaByPk(id: $userMedspaId) {
      payrollShifts(
        where: {
          _and: { endTime: { _isNull: true }, deletedAt: { _isNull: true } }
        }
      ) {
        id
        startTime
        payrollBreaks {
          id
          startTime
          endTime
        }
      }
    }
  }
`;

/**
 * __useCurrentUserOpenShiftQuery__
 *
 * To run a query within a React component, call `useCurrentUserOpenShiftQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserOpenShiftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserOpenShiftQuery({
 *   variables: {
 *      userMedspaId: // value for 'userMedspaId'
 *   },
 * });
 */
export function useCurrentUserOpenShiftQuery(
  baseOptions: Apollo.QueryHookOptions<
    CurrentUserOpenShiftQuery,
    CurrentUserOpenShiftQueryVariables
  > &
    (
      | { variables: CurrentUserOpenShiftQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CurrentUserOpenShiftQuery,
    CurrentUserOpenShiftQueryVariables
  >(CurrentUserOpenShiftDocument, options);
}
export function useCurrentUserOpenShiftLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurrentUserOpenShiftQuery,
    CurrentUserOpenShiftQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CurrentUserOpenShiftQuery,
    CurrentUserOpenShiftQueryVariables
  >(CurrentUserOpenShiftDocument, options);
}
export function useCurrentUserOpenShiftSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CurrentUserOpenShiftQuery,
        CurrentUserOpenShiftQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CurrentUserOpenShiftQuery,
    CurrentUserOpenShiftQueryVariables
  >(CurrentUserOpenShiftDocument, options);
}
export type CurrentUserOpenShiftQueryHookResult = ReturnType<
  typeof useCurrentUserOpenShiftQuery
>;
export type CurrentUserOpenShiftLazyQueryHookResult = ReturnType<
  typeof useCurrentUserOpenShiftLazyQuery
>;
export type CurrentUserOpenShiftSuspenseQueryHookResult = ReturnType<
  typeof useCurrentUserOpenShiftSuspenseQuery
>;
export type CurrentUserOpenShiftQueryResult = Apollo.QueryResult<
  CurrentUserOpenShiftQuery,
  CurrentUserOpenShiftQueryVariables
>;
export const StartWorkShiftDocument = gql`
  mutation StartWorkShift($medspaId: String!) {
    clockin {
      startWorkShift(medspaId: $medspaId) {
        ok
        message
      }
    }
  }
`;
export type StartWorkShiftMutationFn = Apollo.MutationFunction<
  StartWorkShiftMutation,
  StartWorkShiftMutationVariables
>;

/**
 * __useStartWorkShiftMutation__
 *
 * To run a mutation, you first call `useStartWorkShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartWorkShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startWorkShiftMutation, { data, loading, error }] = useStartWorkShiftMutation({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function useStartWorkShiftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartWorkShiftMutation,
    StartWorkShiftMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartWorkShiftMutation,
    StartWorkShiftMutationVariables
  >(StartWorkShiftDocument, options);
}
export type StartWorkShiftMutationHookResult = ReturnType<
  typeof useStartWorkShiftMutation
>;
export type StartWorkShiftMutationResult =
  Apollo.MutationResult<StartWorkShiftMutation>;
export type StartWorkShiftMutationOptions = Apollo.BaseMutationOptions<
  StartWorkShiftMutation,
  StartWorkShiftMutationVariables
>;
export const EndWorkShiftDocument = gql`
  mutation EndWorkShift($medspaId: String!) {
    clockin {
      endWorkShift(medspaId: $medspaId) {
        ok
        message
      }
    }
  }
`;
export type EndWorkShiftMutationFn = Apollo.MutationFunction<
  EndWorkShiftMutation,
  EndWorkShiftMutationVariables
>;

/**
 * __useEndWorkShiftMutation__
 *
 * To run a mutation, you first call `useEndWorkShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndWorkShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endWorkShiftMutation, { data, loading, error }] = useEndWorkShiftMutation({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function useEndWorkShiftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EndWorkShiftMutation,
    EndWorkShiftMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EndWorkShiftMutation,
    EndWorkShiftMutationVariables
  >(EndWorkShiftDocument, options);
}
export type EndWorkShiftMutationHookResult = ReturnType<
  typeof useEndWorkShiftMutation
>;
export type EndWorkShiftMutationResult =
  Apollo.MutationResult<EndWorkShiftMutation>;
export type EndWorkShiftMutationOptions = Apollo.BaseMutationOptions<
  EndWorkShiftMutation,
  EndWorkShiftMutationVariables
>;
export const StartBreakDocument = gql`
  mutation StartBreak($medspaId: String!) {
    clockin {
      startBreak(medspaId: $medspaId) {
        ok
        message
      }
    }
  }
`;
export type StartBreakMutationFn = Apollo.MutationFunction<
  StartBreakMutation,
  StartBreakMutationVariables
>;

/**
 * __useStartBreakMutation__
 *
 * To run a mutation, you first call `useStartBreakMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartBreakMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startBreakMutation, { data, loading, error }] = useStartBreakMutation({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function useStartBreakMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartBreakMutation,
    StartBreakMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartBreakMutation, StartBreakMutationVariables>(
    StartBreakDocument,
    options
  );
}
export type StartBreakMutationHookResult = ReturnType<
  typeof useStartBreakMutation
>;
export type StartBreakMutationResult =
  Apollo.MutationResult<StartBreakMutation>;
export type StartBreakMutationOptions = Apollo.BaseMutationOptions<
  StartBreakMutation,
  StartBreakMutationVariables
>;
export const EndBreakDocument = gql`
  mutation EndBreak($medspaId: String!) {
    clockin {
      endBreak(medspaId: $medspaId) {
        ok
        message
      }
    }
  }
`;
export type EndBreakMutationFn = Apollo.MutationFunction<
  EndBreakMutation,
  EndBreakMutationVariables
>;

/**
 * __useEndBreakMutation__
 *
 * To run a mutation, you first call `useEndBreakMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndBreakMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endBreakMutation, { data, loading, error }] = useEndBreakMutation({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function useEndBreakMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EndBreakMutation,
    EndBreakMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EndBreakMutation, EndBreakMutationVariables>(
    EndBreakDocument,
    options
  );
}
export type EndBreakMutationHookResult = ReturnType<typeof useEndBreakMutation>;
export type EndBreakMutationResult = Apollo.MutationResult<EndBreakMutation>;
export type EndBreakMutationOptions = Apollo.BaseMutationOptions<
  EndBreakMutation,
  EndBreakMutationVariables
>;
export const DeleteShiftDocument = gql`
  mutation DeleteShift($shiftId: String!) {
    clockin {
      deleteWorkShift(shiftId: $shiftId) {
        ok
        message
      }
    }
  }
`;
export type DeleteShiftMutationFn = Apollo.MutationFunction<
  DeleteShiftMutation,
  DeleteShiftMutationVariables
>;

/**
 * __useDeleteShiftMutation__
 *
 * To run a mutation, you first call `useDeleteShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShiftMutation, { data, loading, error }] = useDeleteShiftMutation({
 *   variables: {
 *      shiftId: // value for 'shiftId'
 *   },
 * });
 */
export function useDeleteShiftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteShiftMutation,
    DeleteShiftMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteShiftMutation, DeleteShiftMutationVariables>(
    DeleteShiftDocument,
    options
  );
}
export type DeleteShiftMutationHookResult = ReturnType<
  typeof useDeleteShiftMutation
>;
export type DeleteShiftMutationResult =
  Apollo.MutationResult<DeleteShiftMutation>;
export type DeleteShiftMutationOptions = Apollo.BaseMutationOptions<
  DeleteShiftMutation,
  DeleteShiftMutationVariables
>;
export const ApproveOrDenyShiftsDocument = gql`
  mutation ApproveOrDenyShifts(
    $medspaId: BigInt!
    $approveOrDeny: ApproveOrDeny!
    $shiftIds: [BigInt!]!
  ) {
    clockin {
      approveOrDenyWorkShifts(
        medspaId: $medspaId
        approveOrDeny: $approveOrDeny
        shiftIds: $shiftIds
      ) {
        ok
        message
      }
    }
  }
`;
export type ApproveOrDenyShiftsMutationFn = Apollo.MutationFunction<
  ApproveOrDenyShiftsMutation,
  ApproveOrDenyShiftsMutationVariables
>;

/**
 * __useApproveOrDenyShiftsMutation__
 *
 * To run a mutation, you first call `useApproveOrDenyShiftsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveOrDenyShiftsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveOrDenyShiftsMutation, { data, loading, error }] = useApproveOrDenyShiftsMutation({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *      approveOrDeny: // value for 'approveOrDeny'
 *      shiftIds: // value for 'shiftIds'
 *   },
 * });
 */
export function useApproveOrDenyShiftsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApproveOrDenyShiftsMutation,
    ApproveOrDenyShiftsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApproveOrDenyShiftsMutation,
    ApproveOrDenyShiftsMutationVariables
  >(ApproveOrDenyShiftsDocument, options);
}
export type ApproveOrDenyShiftsMutationHookResult = ReturnType<
  typeof useApproveOrDenyShiftsMutation
>;
export type ApproveOrDenyShiftsMutationResult =
  Apollo.MutationResult<ApproveOrDenyShiftsMutation>;
export type ApproveOrDenyShiftsMutationOptions = Apollo.BaseMutationOptions<
  ApproveOrDenyShiftsMutation,
  ApproveOrDenyShiftsMutationVariables
>;
